import React, {useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Icon from '../../../../../../components/icon';
import Input from '../../../../../../components/input';
import Button from '../../../../../../components/button';
import {
	isAddingNewCustomFieldOption as setIsAddingNewCustomFieldOption,
	postCustomFieldOption,
	submitCustomFieldOption as setSubmitCustomFieldOption,
} from '../../../../../../../actions/customFieldsActions';
import CustomFieldOption from './components/custom-field-option';
import {useTranslation} from 'react-i18next';
import '../../index.css';

/**
 * @return {null}
 */

function CustomFieldDetails () {

	const [newRowOptionValue, setNewRowOptionValue] = useState("");

	const customFieldDetails = useSelector((state) => state.customFieldsReducer.customFieldDetails);
	const isAddingNewCustomFieldOption = useSelector( state => state.customFieldsReducer.isAddingNewCustomFieldOption);
	const submitCustomFieldOption = useSelector( state => state.customFieldsReducer.submitCustomFieldOption);

	const dispatch = useDispatch();

	const {t} = useTranslation();

	const addCustomFieldOptionRef = useRef("");

	if(!customFieldDetails) {
		return null;
	}

	const handleAddOptionRow = () => {
		dispatch(setIsAddingNewCustomFieldOption(true));
	};

	const handleChangeNewRowOptionValue = (e) => {
		setNewRowOptionValue(e.target.value);
	};

	const handleClick = () => {
		dispatch(postCustomFieldOption(
			customFieldDetails.id,
			newRowOptionValue
		));
		dispatch(setSubmitCustomFieldOption("add"));
		setNewRowOptionValue("");
	};

	const handleCancel = () => {
		dispatch(setIsAddingNewCustomFieldOption(false));
		setNewRowOptionValue("");
	};

	return (
		<div className="custom-fields-details">
			<h3>{customFieldDetails.name}</h3>
			<div className="custom-field-options">
				<ul>
					{
						customFieldDetails.dropDownOptions && customFieldDetails.dropDownOptions.length > 0
						?
							customFieldDetails.dropDownOptions.map( dropDownOption => (
								<CustomFieldOption key={dropDownOption.id} item={dropDownOption}/>
							))
						:
							<div className="p-3">
								<em>{t('customFieldsNoRowAddedYet')}</em>
							</div>
					}
				</ul>
				{
					isAddingNewCustomFieldOption && <div className="add-custom-field-option">
						<Input type="text" ref={ addCustomFieldOptionRef } onChange={ handleChangeNewRowOptionValue }/>
					</div>
				}
			</div>
			{
				!isAddingNewCustomFieldOption ? <Button disabled={isAddingNewCustomFieldOption} className="btn-primary" onClick={ handleAddOptionRow }>
					{t('customFieldsAddNewRow')}
				</Button> : submitCustomFieldOption === "add"
					?
					<Button disabled={true} className="btn-primary">
						<Icon animated={'pulse'} name="spinner"/>
					</Button>
					:
					<>
						<Button onClick={handleClick} disabled={newRowOptionValue === ""} className="btn-primary mr-2">
							{t("textSave")}
						</Button>
						<Button onClick={handleCancel} className="btn-outline-primary">
							{t("textCancel")}
						</Button>
					</>
			}
		</div>
	)
}

export default CustomFieldDetails;
